import { render } from "./LockCard.vue?vue&type=template&id=032b310f&scoped=true"
import script from "./LockCard.vue?vue&type=script&lang=js"
export * from "./LockCard.vue?vue&type=script&lang=js"

import "./LockCard.vue?vue&type=style&index=0&id=032b310f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032b310f"]])

export default __exports__